export default __webpack_public_path__ + "static/media/program_intro_16.5cb6ea52.png";